import { FC } from 'react';
import { Badge, BadgeProps, Tooltip } from '@chakra-ui/react';

import { VirusStatus } from '../../graphql/generated';
import { StatusConfig } from './file-status-badge';

type VirusStatusBadgeProps = BadgeProps & {
  virusStatus: VirusStatus;
};

export const VirusStatusMap: Record<string, StatusConfig> = {
  [VirusStatus.QUARANTINED]: {
    label: 'Quarantined',
    colorScheme: 'red',
    tooltip: 'File has been quarantined as it may contain a virus.',
  },
};

export const shouldDisplayBadgeForVirusStatus = (
  status: VirusStatus
): boolean => Object.keys(VirusStatusMap).includes(status) || false;

export const VirusStatusBadge: FC<VirusStatusBadgeProps> = ({
  virusStatus,
  ...rest
}) => {
  const statusMap = VirusStatusMap[virusStatus];
  return (
    <Tooltip label={statusMap.tooltip}>
      <Badge variant="outline" colorScheme={statusMap.colorScheme} {...rest}>
        {statusMap.label}
      </Badge>
    </Tooltip>
  );
};
